import(/* webpackMode: "eager", webpackExports: ["NotFoundClient"] */ "/app/web/app/[locale]/NotFoundClient.tsx");
